import { Component, Input, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-action-button',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.scss',
})
export class ActionButtonComponent implements OnInit {
  @Input() action: 'add' | 'edit' | 'remove' = 'add';
  @Input() disabled = false;
  @Input() text = false;
  @Input() outlined = false;
  @Input() raised = false;
  label = '';
  icon = '';
  cssClass = '';

  /**
   * Initializes the component by setting the label, icon, and CSS class based on the action type.
   * The method handles three actions: 'add', 'edit', and 'remove'.
   * For 'add', it sets the label to 'hinzufügen', the icon to 'fas fa-circle-plus', and appends 'p-button-success' to the CSS class.
   * For 'edit', it sets the label to 'speichern', the icon to 'fas fa-floppy-disk', and appends 'p-button-primary' to the CSS class.
   * For 'remove', it sets the label to 'löschen', the icon to 'fas fa-trash', and appends 'p-button-danger' to the CSS class.
   *
   * @return {void} This method does not return a value.
   */
  ngOnInit(): void {
    switch (this.action) {
      case 'add': {
        this.label = 'hinzufügen';
        this.icon = 'fas fa-circle-plus';
        this.cssClass += 'p-button-success';
        break;
      }
      case 'edit': {
        this.label = 'speichern';
        this.icon = 'fas fa-floppy-disk';
        this.cssClass += 'p-button-primary';
        break;
      }
      case 'remove': {
        this.label = 'löschen';
        this.icon = 'fas fa-trash';
        this.cssClass += 'p-button-danger';
        break;
      }
    }
  }
}
